import { LatLng, getBoundingBox } from "geolocation-utils";

import { Utils } from "utils";
import { uniq } from "lodash";
import { IGraphoopperPath } from "types";
import { DEFAULT_ROUTE_DAY_HOURS } from "constants/constants";

export class Path {
  private path: IGraphoopperPath;

  private _start: LatLng | undefined = undefined;
  private _finish: LatLng | undefined = undefined;

  public constructor(_path: IGraphoopperPath) {
    this.path = _path;
  }

  // Getters

  public get instance() {
    return this.path;
  }

  get tollsCoordinates() {
    console.log({ details: this.path.details });
    const allTolls = this.path.details.toll.filter((i) => i[2] === "all");

    const coordinates = allTolls.map((item) => {
      const [startIndex, endIndex] = item;
      const coords = this.coordinates.slice(startIndex, endIndex);
      return coords;
    });

    return coordinates;
  }

  public get coordinates() {
    const coords = this.path.points.coordinates.map(
      Utils.Graphhopper.convertToLatLng
    );
    return coords;
  }

  public get coordinatesLatLon() {
    const coords = this.path.points.coordinates.map(
      Utils.Graphhopper.convertToLatLon
    );
    return coords;
  }

  public get points() {
    return this.path.points.coordinates;
  }

  public get bounds() {
    const coords = this.coordinatesLatLon;
    const data = Utils.Helpers.createBounds(coords);
    return data;
  }

  public get boundingBox() {
    const bbox = getBoundingBox(this.coordinatesLatLon, 0);
    return bbox;
  }

  public get start() {
    return this._start
      ? this._start
      : Utils.Graphhopper.convertToLatLng(
          this.path.snapped_waypoints.coordinates[0]
        );
  }

  public get finish() {
    return this._finish
      ? this._finish
      : Utils.Graphhopper.convertToLatLng(
          this.path.snapped_waypoints.coordinates[
            this.path.snapped_waypoints.coordinates.length - 1
          ]
        );
  }

  public get curvature() {
    const values = this.path.details.curvature.map((item) => item[2]); // 2 is curve value;
    const averageValue = values.reduce((a, b) => a + b, 0) / values.length;
    return averageValue;
  }

  public get countries() {
    const { country } = this.path.details;
    const values = country.map((item) => item[2]);
    const list = uniq(values)
      .map(Utils.Helpers.getCountryISO2)
      .filter(Boolean) as string[];

    return list;
  }

  public get waypoints() {
    return this.path.snapped_waypoints.coordinates.map(
      Utils.Graphhopper.convertToLatLng
    );
  }

  // Setters

  public set start(coordinate: LatLng) {
    this._start = coordinate;
  }

  public set finish(coordinate: LatLng | undefined) {
    this._finish = coordinate;
  }

  // Methods

  public getDistance(measure: "km" | "m") {
    return measure === "m"
      ? this.path.distance
      : Number((this.path.distance / 1000).toFixed(2));
  }

  public getTime(unit: "hours" | "days" | "minutes") {
    const distance = this.path.distance;
    const averageBikeSpeed = 50; // 50 km/h - average bike speed;
    const maxHoursInRoadByDay = DEFAULT_ROUTE_DAY_HOURS; // hours;

    const hours = distance / 1000 / averageBikeSpeed;

    switch (unit) {
      case "hours": {
        return hours;
      }
      case "minutes": {
        return hours * 60;
      }
      case "days": {
        return Math.trunc(hours / maxHoursInRoadByDay);
      }
    }
  }
}
